"use client";

import { useState, useEffect } from "react";
import { ImageGallery } from "@/@types";
import MainSlider from "./MainSlider";
import ThumbnailSlider from "./ThumbnailSlider";
import FullscreenModal from "./FullscreenModal";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";

type Props = {
  enableFullscreen?: boolean;
  fullscreenWidth?: number;
  fullscreenHeight?: number;
  imagesGallery: ImageGallery[] | null;
  imageWidth?: number;
  imageHeight?: number;
  objectFit?: "cover" | "contain";
  thumbnailWidth?: number;
  thumbnailHeight?: number;
  thumbnailObjectFit?: "cover" | "contain";
  showThumbnails?: boolean;
  showThumbnailsOnMobile?: boolean;
  showNavigationOnThumbnails?: boolean;
};

export default function GalleryImage({
  enableFullscreen = true,
  imagesGallery = [],
  imageWidth,
  imageHeight,
  objectFit = "cover",
  thumbnailWidth = 200,
  thumbnailHeight = 112,
  thumbnailObjectFit = "contain",
  showThumbnails = true,
  showThumbnailsOnMobile = true,
  showNavigationOnThumbnails = false,
  fullscreenWidth = 800,
  fullscreenHeight = 600,
}: Props) {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fullscreenImage, setFullscreenImage] = useState<string | null>(null);

  const closeModal = () => {
    setFullscreenImage(null);
  };

  useEffect(() => {
    if (thumbsSwiper) {
      thumbsSwiper.slideTo(activeIndex);
    }
  }, [activeIndex, thumbsSwiper]);

  return (
    <>
    {fullscreenImage && (
      <FullscreenModal 
        fullscreenImage={fullscreenImage} 
        fullscreenWidth={fullscreenWidth} 
        fullscreenHeight={fullscreenHeight} 
        imagesGallery={imagesGallery}
        currentIndex={activeIndex}
        closeModal={closeModal}
        setCurrentIndex={setActiveIndex}
      />
    )}
      {imagesGallery && imagesGallery.length > 0 ? (
        <div className="relative w-full group">
          <MainSlider
            imagesGallery={imagesGallery}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
            objectFit={objectFit}
            enableFullscreen={enableFullscreen}
            setFullscreenImage={setFullscreenImage}
            setActiveIndex={setActiveIndex}
            thumbsSwiper={thumbsSwiper}
          />
          {showThumbnails && (
            <ThumbnailSlider {...{ imagesGallery, setThumbsSwiper, activeIndex, thumbnailWidth, thumbnailHeight, thumbnailObjectFit, showNavigationOnThumbnails, showThumbnailsOnMobile }} />
          )}
        </div>
      ) : (
        <p className="text-center text-gray-500">No hay imágenes disponibles</p>
      )}
      
    </>
  );
}
